module.exports = "<div class=\"row\" *ngIf=\"isShow\">\r\n  <p class=\"text-danger\">{{msg}}</p>\r\n</div>"